<template>
  <div class="carousel carousel--split">
    <BaseContainer>
      <section class="md:flex md:flex-wrap md:-mx-4">
        <div class="md:flex-1 md:px-4">
          <div :class="getRadius" class="carousel__wrapper">
            <figure class="carousel__image">
              <img :src="getImage" alt="Alt description for the image" />
            </figure>
            <div class="carousel__info">
              <h3 class="carousel__header">
                <TextHeading
                  class="mb-2"
                  color="secondary"
                  variant="sm"
                  block
                  >{{ category }}</TextHeading
                >
                <TextHeading variant="base" block>{{ header }}</TextHeading>
              </h3>
              <p class="carousel__text">{{ info }}</p>
              <BaseButton
                class="carousel__button"
                variant="white"
                aria-label="Latest Morrisons Corporate News"
              >
                <BaseIcon name="arrow_forward" size="28"></BaseIcon>
              </BaseButton>
            </div>
          </div>
        </div>
        <div class="mt-8 md:mt-0 md:w-5/12 lg:w-4/12 md:px-4">
          <div class="block h-full bg-white carousel-shadow md:hidden">
            <a
              class="block twitter-timeline md:hidden"
              data-width="100%"
              data-height="360px"
              data-theme="light"
              href="https://twitter.com/Morrisons?ref_src=twsrc%5Etfw"
              >Tweets by Morrisons</a
            >
          </div>
          <div class="hidden h-full bg-white carousel-shadow md:block">
            <a
              class="twitter-timeline"
              data-width="100%"
              data-height="100%"
              data-theme="light"
              href="https://twitter.com/Morrisons?ref_src=twsrc%5Etfw"
              >Tweets by Morrisons</a
            >
          </div>
        </div>
      </section>
    </BaseContainer>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import BaseContainer from '../elements/BaseContainer.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'PageCarousel',
  components: { TextHeading, BaseContainer, BaseButton, BaseIcon },
  props: {
    category: {
      type: String,
      default: 'Latest News'
    },
    header: {
      type: String,
      default: 'Morrisons is launching a one kilogram Too Good to Waste box'
    },
    info: {
      type: String,
      default:
        'The boxes will be on sale for £1 in every Morrisons nationwide. They are designed to offer customers more of their five-a-day intake on a budget.'
    },
    image01: {
      type: String,
      default: 'morrisons_coronavirus_colleague_bonus.jpg'
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image01)
    },
    getRadius() {
      return `${(this.rounded && 'carousel__wrapper--rounded') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.carousel {
  @apply w-full;
  background-image: linear-gradient(#e7edeb 65%, white 0%);
}
.media-centre__carousel {
  background-image: linear-gradient(#383b3a 65%, white 0%);
}
.carousel__wrapper {
  @apply flex flex-col justify-center w-full overflow-hidden;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
}
.carousel__wrapper--rounded {
  @apply rounded-lg;
}
.carousel__image {
  @apply flex-1 overflow-hidden bg-black;
  flex-basis: auto;
}
.carousel__image img {
  @apply block w-full h-full min-w-full min-h-full object-cover;
}
.carousel__info {
  @apply flex flex-col items-start py-4 px-4 flex-1 bg-white;
  flex-basis: auto;
}
.carousel__header {
  @apply mb-4 w-full;
}
.carousel__text {
  @apply text-lg font-light w-full;
}
.carousel__button {
  @apply text-secondary p-0;
}
.carousel__button:hover {
  @apply text-primary;
}
.carousel__indicator {
  @apply flex justify-center items-end flex-1 self-stretch text-body-lighter text-3xl;
}
@screen sm {
  .carousel__info {
    @apply py-8 px-8;
  }
}
@screen lg {
  .carousel {
    background-image: linear-gradient(#e7edeb 25%, white 0%);
  }
  .media-centre__carousel {
    background-image: linear-gradient(#383b3a 25%, white 0%);
  }
  .carousel__wrapper {
    @apply flex-row;
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
  }
  .carousel__image {
    flex-basis: 50%;
  }
  .carousel__image img {
    @apply max-h-full;
  }
  .carousel__info {
    flex-basis: 50%;
  }
  .carousel__text {
    @apply text-lg mb-8;
  }
}
@screen lg {
  .carousel__info {
    @apply pt-16 pb-8;
  }
}
.carousel-shadow {
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
}
</style>
